// src/features/dashboard/components/MonthlyProductivity.tsx

import {
  useMonthlyProductivity,
} from '../hooks/Employee/useMonthlyProductivity';

const MonthlyProductivity = () => {
  const {
    data,
    loading,
  } = useMonthlyProductivity();

  if (loading || !data) {
    return null;
  }

  /* ============================================================
     PRODUCTIVITY VALUE
     ============================================================ */

  const productivity = Math.max(
    0,
    Math.min(
      100,
      Number(data.averageProductivity) || 0,
    ),
  );

  const progressAngle =
    productivity * 3.6;


  /* ============================================================
     RENDER
     ============================================================ */

  return (
    <div
      className="
        flex
        h-full
        min-h-0
        w-full
        min-w-0
        flex-col
        overflow-hidden
        rounded-[16px]
        border
        border-[#D0D5DD]
        bg-white
        px-[14px]
        py-[12px]

        sm:px-[16px]
        sm:py-[14px]
      "
    >

      {/* ========================================================
          HEADER
      ======================================================== */}

      <div
        className="
          flex
          min-w-0
          flex-wrap
          items-center
          gap-[8px]
        "
      >

        <h2
          className="
            min-w-0
            truncate
            text-[12px]
            font-semibold
            leading-[18px]
            text-[#002B5B]

            sm:text-[13px]
          "
        >
          Monthly Avg Productivity
        </h2>


        <div
          className="
            shrink-0
            rounded-full
            bg-[#EAF2FF]
            px-[8px]
            py-[3px]
            text-[8px]
            font-medium
            leading-[12px]
            text-[#1565D8]

            sm:px-[9px]
            sm:text-[9px]
          "
        >
          {data.badgeText}
        </div>

      </div>


      {/* ========================================================
          PRODUCTIVITY CIRCLE
      ======================================================== */}

      <div
        className="
          flex
          w-full
          min-w-0
          items-center
          justify-center
          py-[8px]

          sm:py-[10px]
        "
      >

        <div
          className="
            relative
            flex
            h-[170px]
            w-[170px]
            shrink-0
            items-center
            justify-center
            rounded-full

            sm:h-[180px]
            sm:w-[180px]
          "
          style={{
            background: `
              conic-gradient(
                #3A7F4E 0deg ${progressAngle}deg,
                #E4E7EC ${progressAngle}deg 360deg
              )
            `,
          }}
        >

          {/* ==================================================
              WHITE CENTER
          ================================================== */}

          <div
            className="
              flex
              h-[140px]
              w-[140px]
              items-center
              justify-center
              rounded-full
              bg-white

              sm:h-[148px]
              sm:w-[148px]
            "
          >

            <div
              className="
                flex
                flex-col
                items-center
                justify-center
              "
            >

              {/* VALUE */}

              <span
                className="
                  text-[30px]
                  font-semibold
                  leading-none
                  text-[#002B5B]

                  sm:text-[32px]
                "
              >
                {productivity}%
              </span>


              {/* AVG */}

              <span
                className="
                  mt-[5px]
                  text-[10px]
                  font-medium
                  uppercase
                  tracking-[0.5px]
                  text-[#667085]

                  sm:text-[11px]
                "
              >
                AVG
              </span>

            </div>

          </div>

        </div>

      </div>


      {/* ========================================================
          METRICS
      ======================================================== */}

      <div
        className="
          mt-[6px]
          flex
          flex-col
          gap-[9px]

          sm:mt-[8px]
          sm:gap-[10px]
        "
      >

        {data.metrics.map(
          (item) => (

            <div
              key={item.label}
              className="
                flex
                min-w-0
                items-center
                justify-between
                gap-3
              "
            >

              {/* ----------------------------------------------
                  LABEL
              ---------------------------------------------- */}

              <span
                className="
                  min-w-0
                  truncate
                  text-[10px]
                  font-medium
                  leading-[14px]
                  text-[#344054]

                  sm:text-[11px]
                "
                title={item.label}
              >
                {item.label}
              </span>


              {/* ----------------------------------------------
                  VALUE
              ---------------------------------------------- */}

              <span
                className={`
                  shrink-0
                  whitespace-nowrap
                  text-[10px]
                  font-semibold
                  leading-[14px]

                  sm:text-[11px]

                  ${item.color || 'text-[#101828]'}
                `}
                title={item.value}
              >
                {item.value}
              </span>

            </div>

          ),
        )}

      </div>

    </div>
  );
};

export default MonthlyProductivity;